import { useMutation } from '@tanstack/react-query';

import { markOrderRead } from '../../../common/api/clients/order.api';

export const useMarkOrderRead = () => {
    return useMutation({ mutationFn: markOrderRead });
};
